import HelperMixin from '../../Shared/HelperMixin.vue';

export default {
    name: 'OpeningStockImport',
    mixins: [HelperMixin],

    computed: {
        showOpeningImportCard() {
            return this.canWarehouseInventoryLinesUi() || this.hasInventoryAndStockAccessUi();
        }
    },

    data() {
        return {
            invUi: null,
            stockings: [],
            openingImportStockingId: null,
            openingImportFile: null,
            openingFileDragOver: false,
            openingWorkflowOnly: true,
            openingRelaxNationalGrants: true,
            openingGrantsVisible: false,
            openingGrantsPage: 1,
            openingGrantsPageSize: 50,
            openingGrantsSearch: '',
            openingGrantsTotal: 0,
            openingGrantsRows: []
        };
    },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewInventoryCountsUi()) {
            this.logout();
            return;
        }
        await this.loadInventoryUiContext();
        this.loadStockings();
    },

    methods: {
        goInventoryCounts() {
            this.$router.push('/InventoryCounts');
        },
        loadInventoryUiContext() {
            return this.$http
                .GetInventoryUiContext()
                .then((res) => {
                    this.invUi = res.data || null;
                })
                .catch(() => {
                    this.invUi = null;
                });
        },
        loadStockings() {
            this.$http
                .GetAllStocking()
                .then((response) => {
                    this.stockings = response.data.info || response.data || [];
                    if (this.openingImportStockingId == null && this.stockings.length) {
                        this.openingImportStockingId = this.stockings[0].id;
                    }
                })
                .catch(() => {
                    this.stockings = [];
                });
        },
        escapeHtmlForSwal(text) {
            return String(text || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        },
        formatOpeningImportErrorHtml(err) {
            const res = err && err.response;
            const data = res && res.data;
            const status = res && res.status;

            if (data == null || data === '') {
                const fallback =
                    (err && err.message) ||
                    (status ? 'تعذر إتمام الطلب (رمز HTTP ' + status + ').' : 'تعذر إتمام الطلب.');
                return this.escapeHtmlForSwal(fallback);
            }

            if (typeof data === 'string') {
                const s = data.trim();
                if (s.startsWith('<!') || s.toLowerCase().startsWith('<html')) {
                    return this.escapeHtmlForSwal(
                        status === 401 || status === 403
                            ? 'انتهت الجلسة أو لا تملك صلاحية. أعد تسجيل الدخول وحاول مرة أخرى.'
                            : 'استجابة غير متوقعة من الخادم. أعد المحاولة أو راجع مسؤول النظام.'
                    );
                }
                return this.escapeHtmlForSwal(s).replace(/\r\n|\r|\n/g, '<br/>');
            }

            const baseMsg =
                data.message ||
                data.Message ||
                data.title ||
                data.Title ||
                data.detail ||
                data.Detail ||
                '';

            const rawErrs = data.errors != null ? data.errors : data.Errors;
            const lines = [];
            if (Array.isArray(rawErrs)) {
                rawErrs.forEach((e) => {
                    if (e != null && e !== '') lines.push(String(e));
                });
            } else if (rawErrs && typeof rawErrs === 'object') {
                Object.keys(rawErrs).forEach((k) => {
                    const v = rawErrs[k];
                    if (Array.isArray(v)) v.forEach((x) => x != null && lines.push(String(x)));
                    else if (v != null) lines.push(String(v));
                });
            }

            let combined = baseMsg ? String(baseMsg) : '';
            if (lines.length) {
                const block = lines.join('\n');
                combined = combined ? combined + '\n\n' + block : block;
            }

            if (!combined) {
                try {
                    combined = JSON.stringify(data);
                    if (combined.length > 1200) combined = combined.slice(0, 1200) + '…';
                } catch (e) {
                    combined = status ? 'فشل الاستيراد (رمز ' + status + ').' : 'فشل الاستيراد.';
                }
            }

            return this.escapeHtmlForSwal(combined).replace(/\r\n|\r|\n/g, '<br/>');
        },
        openOpeningFilePicker() {
            const input = this.$refs.openingFileInput;
            if (input) input.click();
        },
        onOpeningDragOver(e) {
            if (e && e.dataTransfer) e.dataTransfer.dropEffect = 'copy';
            this.openingFileDragOver = true;
        },
        onOpeningDragLeave() {
            this.openingFileDragOver = false;
        },
        onOpeningFileDrop(e) {
            this.openingFileDragOver = false;
            const f = e && e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
            if (!f) return;
            if (!/\.(xlsx|xls)$/i.test(f.name)) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار ملف Excel بصيغة .xlsx أو .xls');
                return;
            }
            this.openingImportFile = f;
        },
        clearOpeningImportFile() {
            this.openingImportFile = null;
            const input = this.$refs.openingFileInput;
            if (input) input.value = '';
        },
        loadOpeningGrants(page) {
            if (!this.openingImportStockingId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر المخزن أولاً.');
                return;
            }
            this.openingGrantsPage = page || 1;
            this.$blockUI.Start();
            this.$http
                .GetGrantedOpeningProducts(this.openingImportStockingId, this.openingGrantsPage, this.openingGrantsPageSize, this.openingGrantsSearch)
                .then((res) => {
                    this.$blockUI.Stop();
                    this.openingGrantsRows = res.data.info || [];
                    this.openingGrantsTotal = res.data.count || 0;
                    this.openingGrantsVisible = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.openingGrantsRows = [];
                    this.openingGrantsTotal = 0;
                });
        },
        onOpeningFileChange(e) {
            const f = e && e.target && e.target.files && e.target.files[0];
            if (f && !/\.(xlsx|xls)$/i.test(f.name)) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار ملف Excel بصيغة .xlsx أو .xls');
                e.target.value = '';
                this.openingImportFile = null;
                return;
            }
            this.openingImportFile = f || null;
        },
        downloadOpeningTemplate() {
            if (!this.openingImportStockingId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر المخزن أولاً.');
                return;
            }
            this.$blockUI.Start();
            this.$http
                .DownloadOpeningStockTemplate(this.openingImportStockingId)
                .then((res) => {
                    this.$blockUI.Stop();
                    const blob = new Blob([res.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `OpeningStock-template-${this.openingImportStockingId}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    this.$helper.ShowMessage('success', 'تم', 'تم تنزيل القالب.');
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('error', 'خطأ', 'تعذر تنزيل القالب.');
                });
        },
        submitOpeningImport() {
            if (!this.openingImportStockingId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر المخزن.');
                return;
            }
            if (!this.openingImportFile) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر ملف Excel.');
                return;
            }
            const fd = new FormData();
            fd.append('stockingId', String(this.openingImportStockingId));
            fd.append('file', this.openingImportFile);
            fd.append('workflowOnly', this.openingWorkflowOnly ? 'true' : 'false');
            fd.append('relaxNationalGrants', this.openingRelaxNationalGrants ? 'true' : 'false');
            this.$blockUI.Start();
            this.$http
                .ImportOpeningStock(fd)
                .then((res) => {
                    this.$blockUI.Stop();
                    const d = res.data || {};
                    const extra =
                        d.errors && d.errors.length ? '\n' + d.errors.slice(0, 8).join('\n') + (d.errors.length > 8 ? '\n…' : '') : '';
                    this.$helper.ShowMessage('success', 'تم', (d.message || 'تم الاستيراد.') + extra);
                    this.clearOpeningImportFile();
                    this.loadInventoryUiContext();
                    if (d.sessionId) {
                        this.$router.push({ path: '/InventoryCounts', query: { id: String(d.sessionId) } });
                    }
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const html =
                        '<div dir="rtl" style="text-align:right;max-height:min(55vh,420px);overflow-y:auto;font-size:0.95rem;line-height:1.45">' +
                        this.formatOpeningImportErrorHtml(err) +
                        '</div>';
                    this.$helper.ShowMessage('error', 'خطأ في الاستيراد', html);
                });
        }
    }
};
